import type { QueryKey } from "@tanstack/react-query";

/** Query-key factory for the broker entity (dealKeys-style). Every broker
 * read registers under the `brokerKeys.all` prefix so a mutation can cover
 * detail + table + pipeline + alerts + gates with ONE prefix invalidation.
 * Other modules (portal-account cross-links, collection staging import)
 * import `all`/`detail` — do not rename those two. */
export const brokerKeys = {
  all: ["brokers"] as const,
  lists: () => [...brokerKeys.all, "list"] as const,
  table: (state: unknown, tab: string, page: number): QueryKey =>
    [...brokerKeys.lists(), "table", state, tab, page],
  pipeline: (assignedToMe: boolean): QueryKey =>
    [...brokerKeys.lists(), "pipeline", assignedToMe],
  alerts: () => [...brokerKeys.all, "alerts"] as const,
  wizardSearch: (search: string): QueryKey => [...brokerKeys.all, "wizard", search],
  details: () => [...brokerKeys.all, "detail"] as const,
  detail: (id: string) => [...brokerKeys.details(), id] as const,
  inviteStatus: (id: string): QueryKey => [...brokerKeys.detail(id), "invite-status"],
  outstandingDeals: (id: string): QueryKey => [...brokerKeys.detail(id), "outstanding-deals"],
  transitions: (id: string): QueryKey => [...brokerKeys.detail(id), "transitions"],
  stageReadiness: (id: string): QueryKey => [...brokerKeys.detail(id), "stage-readiness"],
  certifications: (id: string): QueryKey => [...brokerKeys.detail(id), "certifications"],
};

export const brokerTeamKeys = {
  all: ["broker-teams"] as const,
  list: (includeArchived: boolean): QueryKey => [...brokerTeamKeys.all, "list", includeArchived],
  dashboard: (id: string): QueryKey => [...brokerTeamKeys.all, "dashboard", id],
  eligibleBrokers: (): QueryKey => [...brokerTeamKeys.all, "eligible-brokers"],
};
